import classes from './FormRedirect.module.scss';
import Image from 'next/image';

export default function PartnerFormRedirect() {
    return (
        <div className={classes.oPartnerFormRedirect}>
            <div className={`${classes['true']} ${classes.oSubmitted}`}>
                <figure className={classes.mIcon}>
                    <Image
                        src="/web/images/unsubscribe/icon-envelope.svg"
                        alt="arrow"
                        width={72}
                        height={70}
                        layout="fixed"
                    />
                </figure>
                <h2 className={`${classes.aTitle} fnt24f`}>Thank you!</h2>
                <p className={`${classes.aText} fnt16f`}>
                    Your message has been sent. <br />
                    If a reply is needed, we will contact you shortly.
                </p>
            </div>
        </div>
    );
}
